import _ from 'lodash';

export function formatDistance(meters) {
    if (meters >= 1000) {
        return `${_.round(meters / 1000, 1)} км`;
    }

    return `${meters} м`;
}

export function formatTime(minutes) {
    if (minutes >= 60) {
        return `${_.floor(minutes / 60)} ч ${_.padStart(minutes % 60, 2, '0')} мин`;
    }

    return `${minutes} мин`;
}

export function find(object, search) {
    try {
        if (_.find(object, search)) {
            const result = _.find(object, search);
            let submenu = result.submenu ? result.submenu : [];
            submenu = new Proxy(submenu, {
                get(target, prop) {
                    if (prop in target) {
                        return target[prop];
                    } else {
                        console.warn(`submenu by index: ${prop} not found in ${result.text}`)
                        return {
                            show: false
                        };
                    }
                }
            });
            return {text: result.text, show: result.show, submenu: submenu}
        } else {
            console.warn(`Not find in settings.json ${search}`);
            return {
                show: false,
            }
        }
    } catch (e) {
        console.warn(`Not find in settings.json ${search}`);
        return {
            show: false,
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/functions.js